export enum SelectionType {
  METRIC = 'metric',
  SCALE = 'scale',
  BENCHMARK = 'benchmark',
  CLASS = 'class',
  STUDENT = 'student',
  SCHOOL = 'school',
}

export enum State {
  NONE = 'NONE',
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum DropdownType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  HEADER = 'header',
}

export enum ReportType {
  BENCHMARK = 'BENCHMARK',
  TRACKING = 'TRACKING',
  PROGRESS = 'PROGRESS',
  PARENT = 'PARENT',
  DIAGNOSTIC = 'DIAGNOSTIC',
  PLANNING = 'PLANNING',
  DYSLEXIA = 'DYSLEXIA',
  DYSLEXIARISK = 'DYSLEXIARISK',
  READINGROPE = 'READINGROPE',
  SKILLSSTATUS = 'SKILLSSTATUS',
  SKILLSDIAGNOSTIC = 'SKILLSDIAGNOSTIC',
  BADGING = 'BADGING',
  CLASSPROGRESS = 'CLASSPROGRESS',
  STANDARDSMASTERY = 'STANDARDSMASTERY',
  STUDENTSUMMARY = 'STUDENTSUMMARY',
}